// extracted by mini-css-extract-plugin
module.exports = {"spotlightOverlay":"_spotlightOverlay--KIW6E"};